module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.8609/js/img/MarketingHub_Icon.svg"